export const DEFAULT_ASSISTANT_BASE_PATH = 'ai/coach-gpt';

export const getAssistantEndpoints = (basePath = DEFAULT_ASSISTANT_BASE_PATH) => {
  const sessionsPath = `${basePath}/sessions`;
  const sessionIdPath = `${sessionsPath}/:sessionId`;

  return {
    responses: `${basePath}/responses`,
    sessions: sessionsPath,
    sessionDelete: sessionIdPath,
    sessionPin: `${sessionIdPath}/pin`,
    sessionSearch: `${basePath}/search`,
    sessionUnpin: `${sessionIdPath}/unpin`,
    sessionUpdate: sessionIdPath
  };
};

export const ENDPOINTS = getAssistantEndpoints();
